<form [formGroup]="form" class="tester-form">
  <p class="text-muted mb-15" style="font-size: 13px;">
    Ingresa el monto y la tasa (anual o mensual), y la cuota o el plazo. El resto de campos son
    opcionales (abonos a capital).
  </p>

  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Monto del préstamo *</mat-label>
        <input matInput formControlName="loan_amount" type="number" />
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Tasa anual E.A. (%)</mat-label>
        <input matInput formControlName="annual_rate" type="number" />
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Tasa mensual E.M. (%)</mat-label>
        <input matInput formControlName="monthly_rate" type="number" />
      </mat-form-field>
    </div>

    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Plazo (meses, máx 60)</mat-label>
        <input matInput formControlName="loan_term" type="number" />
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Cuota mensual</mat-label>
        <input matInput formControlName="loan_payment" type="number" />
      </mat-form-field>
    </div>
  </div>

  <mat-divider class="mt-10 mb-15"></mat-divider>
  <p class="text-muted mb-10" style="font-size: 13px;">Abonos a capital (opcional):</p>
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Abono 1 - Monto</mat-label>
        <input matInput formControlName="capital_payment_amount" type="number" />
      </mat-form-field>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Abono 1 - Mes</mat-label>
        <input matInput formControlName="capital_payment_month" type="number" />
      </mat-form-field>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Abono 2 - Monto</mat-label>
        <input matInput formControlName="second_payment_amount" type="number" />
      </mat-form-field>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Abono 2 - Mes</mat-label>
        <input matInput formControlName="additional_payment_month" type="number" />
      </mat-form-field>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Abono 3 - Monto</mat-label>
        <input matInput formControlName="third_payment_amount" type="number" />
      </mat-form-field>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Abono 3 - Mes</mat-label>
        <input matInput formControlName="third_capital_payment_month" type="number" />
      </mat-form-field>
    </div>
  </div>

  <div class="text-right" style="text-align: right;">
    <button mat-button class="default-btn" type="button" (click)="reset()">Limpiar</button>
    <button
      mat-raised-button
      class="default-btn bg-main-color-blue"
      type="button"
      [disabled]="isLoading"
      (click)="onSubmit()"
    >
      {{ isLoading ? "Calculando..." : "Simular crédito" }}
    </button>
  </div>
</form>

<div *ngIf="errorMessage" class="alert-message error-message mt-15">
  {{ errorMessage }}
</div>

<div *ngIf="result" class="result-card mt-15">
  <h5 class="title-color">📊 Resultado de la simulación</h5>
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12"><strong>Préstamo:</strong> {{ result.prestamo }}</div>
    <div class="col-lg-4 col-md-6 col-sm-12"><strong>Tasa E.A.:</strong> {{ result.tasaAnualEA }}</div>
    <div class="col-lg-4 col-md-6 col-sm-12"><strong>Tasa E.M.:</strong> {{ result.tasaMensualEM }}</div>
    <div class="col-lg-4 col-md-6 col-sm-12"><strong>Plazo:</strong> {{ result.plazo }} meses</div>
    <div class="col-lg-4 col-md-6 col-sm-12"><strong>Cuota:</strong> {{ result.cuota }}</div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <strong>Total pago:</strong> {{ result.totalPago | number: "1.0-0" }}
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <strong>Total capital:</strong> {{ result.totalCapital | number: "1.0-0" }}
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <strong>Total intereses:</strong> {{ result.totalIntereses | number: "1.0-0" }}
    </div>
  </div>
  <div *ngIf="abonosList.length" class="mt-10">
    <strong>Abonos a capital:</strong>
    <ul>
      <li *ngFor="let abono of abonosList">{{ abono }}</li>
    </ul>
  </div>
</div>
